<!-- @format -->

<div class="team-profiles-container">
	<div class="row m-0 btm-row">
		<div class="col-3 p-0">
			<div class="select-title border-btm">
				<h4 class="m-0">Select team member:</h4>
			</div>

			<div class="p-0">
				<ng-container *ngFor="let user of users; let i = index">
					<div class="employee border-btm" [class.selected]="selectedUser.id == user.id" (click)="viewProfileDetails(user)">
						<div class="d-flex justify-content-space">
							<label class="container d-flex">
								<div class="img">
									<img class="profile_icon" [src]="getProfilePicture(user)" />
								</div>
								<div class="employeeName">{{getUserName(user)}}</div>
							</label>
						</div>
					</div>
				</ng-container>
			</div>
		</div>

		<div class="col-9 p-0">
			<div class="d-flex top-row m-0 week-range border-left justify-content-between">
				<div class="p-2 heading">
					<h2>Team profile</h2>
					<p *ngIf="selectedUser.id === -1">Select a team member's profile from the left panel to manage.</p>

					<div class="configDatePrompt" *ngIf="selectedUser.id !== -1">
						<!-- <div class="promptIcon"><i class="fa-regular fa-circle-exclamation"></i></div> -->
						<div class="promptMsg">
							<span>
								If your staff started work partway through a pay period, they should submit their hours for this period to you
								manually. They can begin using the Timesheet App in the next pay period.
							</span>
						</div>
					</div>

					<div class="msgContainer" *ngIf="selectedUser.id !== -1">
						<div class="msgText">
							<p>Viewing {{getUserName(selectedUser)}}'s profile records.</p>
						</div>

						<div class="addRecord">
							<span class="addRecord" (click)="onAddRow()">Update profile</span>
						</div>
					</div>
				</div>
			</div>

			<div class="btm-row entries m-0 border-left">
				<table class="table" *ngIf="selectedUser.id !== -1">
					<tr>
						<th>Effective date</th>
						<th>Employment status</th>
						<th>Hours per pay period</th>
						<th>CDO day</th>
						<th>Regular day hours</th>
						<th>Adjusted day</th>
						<th>Adjusted day hours</th>
						<th>Employee type</th>
						<th>Status</th>
					</tr>

					<!-- <tr class="configEntry" *ngFor="let config of userConfigurations" (click)="onConfigClick(config)"> -->
					<tr class="configEntry" *ngFor="let config of userConfigurations">
						<!-- <td>{{getUserName(selectedUser)}}</td> -->
						<td>{{getDateString(config.startingDate)}}</td>
						<td>{{getEmploymentStatus(config.employmentStatus)}}</td>
						<td>{{config.hoursPerPayPeriod}}</td>
						<td>{{getCDODay(config)}}</td>
						<td>{{config.durationOfRegularDay}}</td>
						<td>{{getModifiedDurationDay(config)}}</td>
						<td>{{getModifiedDurationHrs(config)}}</td>
						<td>{{getEmployeeType(config.unionCode)}}</td>
						<td>{{getActiveStatus(config)}}</td>
					</tr>
				</table>
			</div>
		</div>
	</div>
</div>

<ng-template #configModal>
	<div class="team-profiles-modal-container">
		<form [formGroup]="memberForm">
			<div class="config-modal">
				<div class="modal-header">
					<h4 class="modal-title" id="modal-basic-title" *ngIf="isUpdateModal">Edit Profile Record</h4>

					<h4 class="modal-title" id="modal-basic-title" *ngIf="!isUpdateModal">Add Profile Record</h4>

					<button type="button" class="btn-close" aria-label="Close" (click)="dismissModal()"></button>
				</div>

				<div class="row mb-3">
					<div class="col-4">
						<label class="form-label">Effective Date</label>
					</div>

					<div class="col-8 startDatePicker">
						<div class="input-group">
							<div class="control-wrapper">
								<input
									class="form-control invisible p-0 datePicker-invisible"
									placeholder="yyyy-mm-dd"
									name="dp1"
									ngbDatepicker
									#d1="ngbDatepicker"
									[firstDayOfWeek]="6"
									[dayTemplate]="startDaysList"
									[weekdays]="1"
									[placement]="'bottom-start'"
									[navigation]="'arrows'"
									[startDate]="ngbStartDate"
									[markDisabled]="isDateDisabled"
									(dateSelect)="onDateSelect($event, 'startDate')" />

								<input
									class="form-control input-field"
									type="text"
									formControlName="startDate"
									(click)="d1.toggle();"
									placeholder="Select start date"
									[attr.disabled]="userConfigurations.length == 0 ? '' : null" />

								<ng-template #startDaysList let-date let-currentMonth="currentMonth">
									<span [class.shade]="shouldDarkenEntryBG(date)" [class.outsideMonth]="date.month !== currentMonth">
										<span [class.selectedDate]="isSelectedDate(date, 'startDate')">
											{{ date.day }}
										</span>
									</span>
								</ng-template>
							</div>

							<button
								class="btn btn-outline-secondary"
								(click)="d1.toggle();"
								type="button"
								[disabled]="userConfigurations.length == 0">
								<i class="fa-regular fa-calendar"></i>
							</button>
						</div>

						<div *ngIf="userConfigurations.length === 0" class="dateLockedNote">
							<span>Note:</span> This field is locked as the application requires the initial profile to be set at the provided date.
						</div>
					</div>
				</div>

				<div class="row mb-3">
					<div class="col-4">
						<label class="form-label">Employment Status</label>
					</div>

					<div class="col-8">
						<select class="form-select" formControlName="employmentStatus" (change)="updateEmpStatusAffectedFields()">
							<option [value]="-1" selected disabled>Select one</option>
							<ng-container *ngFor="let emp of empStatus">
								<option [ngValue]="emp.code">
									{{emp.desc}}
								</option>
							</ng-container>
						</select>
					</div>
				</div>

				<div class="row mb-3">
					<div class="col-4">
						<label class="form-label">Hours Per Pay Period</label>
					</div>

					<div class="col-8" [class.invalid]="hoursPerPP?.invalid && hoursPerPP?.touched">
						<input type="text" class="form-control" formControlName="hoursPerPP" />
					</div>
				</div>

				<div class="row mb-3">
					<div class="col-4">
						<label class="form-label">CDO Day</label>
					</div>

					<div class="col-8">
						<select class="form-select" formControlName="cdoDay" (change)="updateCDOAffectedFields()">
							<option [value]="-1" selected disabled>Select one</option>
							<option value="0">Not Enrolled</option>
							<ng-container *ngFor="let wk of [1, 2]">
								<optgroup label="Week {{wk}}">
									<ng-container *ngFor="let day of oneWeek">
										<option [ngValue]="wk === 1 ? day : day + 7">Week {{wk}} {{ getDayOfWeek(day) }}</option>
									</ng-container>
								</optgroup>
							</ng-container>
						</select>
					</div>
				</div>

				<div class="row mb-3">
					<div class="col-4">
						<label class="form-label">Regular Day Hours</label>
					</div>

					<div class="col-8" [class.invalid]="regDayHrs?.invalid && regDayHrs?.touched">
						<input type="text" class="form-control" formControlName="regDayHrs" />
					</div>
				</div>

				<div class="row mb-3">
					<div class="col-4">
						<label class="form-label">Adjusted Hours Day</label>
					</div>

					<div class="col-8">
						<select class="form-select" formControlName="adjHoursDay">
							<option [value]="-1" disabled selected>Select one</option>
							<option value="0">Not Applicable</option>
							<ng-container *ngFor="let wk of [1,2]">
								<optgroup label="Week {{wk}}">
									<ng-container *ngFor="let day of oneWeek">
										<option [ngValue]="wk === 1 ? day : day + 7">Week {{wk}} {{ getDayOfWeek(day) }}</option>
									</ng-container>
								</optgroup>
							</ng-container>
						</select>
					</div>
				</div>

				<div class="row mb-3">
					<div class="col-4">
						<label class="form-label">Adjusted Hours</label>
					</div>

					<div class="col-8" [class.invalid]="adjHours?.invalid && adjHours?.touched">
						<input type="text" class="form-control" formControlName="adjHours" />
					</div>
				</div>

				<div class="row mb-3">
					<div class="col-4">
						<label class="form-label">Employee Type</label>
					</div>

					<div class="col-8">
						<select class="form-select" formControlName="unionCode">
							<option [value]="-1" selected disabled>Select one</option>
							<option value="Union">Union</option>
							<option value="ExemptManagement">Exempt Management</option>
							<option value="ExemptSupport">Exempt Support</option>
						</select>
					</div>
				</div>

				<div class="text-danger" *ngIf="hoursPerPP?.errors?.pattern || regDayHrs?.errors?.pattern || adjHours?.errors?.pattern">
					*Please enter numbers only
				</div>

				<div class="d-flex justify-content-between mt-4">
					<button type="button" class="btn btn-link btn-submission-cancel" (click)="dismissModal()">Cancel</button>
					<button
						class="btn btn-primary"
						type="submit"
						title="Submit"
						(click)="dismissModal(true)"
						[disabled]="memberForm.invalid || employmentStatus?.value == -1 || 
                                    adjHoursDay?.value == -1 || cdoDay?.value == -1 || unionCode?.value == -1">
						{{ isUpdateModal ? "Update" : "Save"}}
					</button>
				</div>
			</div>
		</form>
	</div>
</ng-template>
